import ApiService from "@/api";
import { NamespaceModel, ResponseModel, UpdateNamespaceModel } from "../models";
import {
  mapGetColorsResponse,
  mapGetIconsResponse,
  mapGetNamespaceRequest,
  mapGetNamespaceResponse,
  mapUpdateNamespaceRequest,
} from "./AdapterServiceMappers";
import { IconColorType, IconType } from "tir-components";
import GetIconListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-icon/GetIconListRequest";
import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import GetColorListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-color/GetColorListRequest";

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * * Получить информацию о неймспейса
   * @param namespaceId ID неймспейса
   * @returns
   */
  getNamespace(namespaceId: string) {
    return new Promise<ResponseModel<NamespaceModel>>(async (resolve) => {
      const result = new ResponseModel<NamespaceModel>();

      await this.api.Main.ProjectNamespaceService.getNamespaceByIdAsync(
        mapGetNamespaceRequest(namespaceId),
      )
        .then((resp) => {
          result.Value = mapGetNamespaceResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getNamespace", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Обновить неймспейс
   * @param request
   * @returns
   */
  updateNamespace(request: UpdateNamespaceModel) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.ProjectNamespaceService.updateAsync(mapUpdateNamespaceRequest(request))
        .then((resp) => {
          result.Value = true;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR updateNamespace", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить иконки
   * @returns
   */
  getIcons() {
    return new Promise<ResponseModel<Array<IconType>>>(async (resolve) => {
      const result = new ResponseModel<Array<IconType>>();

      await this.api.Main.SettingIconService.getIconListAsync(
        new GetIconListRequest({ Page: new PageRequest({ Skip: 0, Take: 100 }) }),
      )
        .then((resp) => {
          result.Value = mapGetIconsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getIcons", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить цвета иконок
   * @returns
   */
  getColors() {
    return new Promise<ResponseModel<Array<IconColorType>>>(async (resolve) => {
      const result = new ResponseModel<Array<IconColorType>>();

      await this.api.Main.SettingColorService.getColorListAsync(
        new GetColorListRequest({ Page: new PageRequest({ Skip: 0, Take: 100 }) }),
      )
        .then((resp) => {
          result.Value = mapGetColorsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getColors", e);
          return resolve(result);
        });
    });
  }
}
